import { Alert, Button, Stack } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormatDate } from '@pflegenavi/frontend/localization';
import { YEAR_MONTH_DAY_SHORT_FORMAT } from '@pflegenavi/shared/constants';
import type { KycWarning } from '@pflegenavi/shared-frontend/platform';

interface KycVerificationBannerViewProps {
  warning: KycWarning;
  hostedIdv: boolean;
  renewalDeadline: string | null;
  onAction: () => void;
}

export const KycVerificationBannerView: FC<KycVerificationBannerViewProps> = ({
  warning,
  hostedIdv,
  renewalDeadline,
  onAction,
}) => {
  const { t } = useTranslation();
  const formatDate = useFormatDate();

  return (
    <Alert
      severity="warning"
      sx={{ mb: 3 }}
      action={
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: 'center',
          }}
        >
          <Button
            color="inherit"
            size="small"
            variant="outlined"
            onClick={onAction}
          >
            {warning === 'renewal_due'
              ? t('kyc.idv.renew-button')
              : hostedIdv
              ? t('kyc.idv.verify-button')
              : t('service-provider-app.dashboard.complete-kyc-button')}
          </Button>
        </Stack>
      }
    >
      {warning === 'renewal_due' && renewalDeadline
        ? t('kyc.idv.banner.renewal-due', {
            date: formatDate(
              new Date(renewalDeadline),
              YEAR_MONTH_DAY_SHORT_FORMAT
            ),
          })
        : hostedIdv
        ? t('kyc.idv.banner.service-provider-not-verified')
        : t('service-provider-app.dashboard.kyc-verification-required')}
    </Alert>
  );
};
